export default __webpack_public_path__ + "static/media/twitter.6d2f15ab.svg";